import React, { createRef } from 'react';
import { Link } from 'react-router-dom';
import styles from './RateView.module.css';
import config from '../../config/config';

import ButtonIconText from '../button/ButtonIconText';
import ButtonChangeOwner from './ButtonChangeOwner';
import ButtonFieldUpdate from './ButtonFieldUpdate';
import ButtonGlobalIdUpdate from './ButtonGlobalIdUpdate';
import ButtonMergeInstances from './ButtonMergeInstances';
import ButtonViewConditions from './conditions/ButtonViewConditions';
import ButtonSendEmail from './button/ButtonSendEmail';
import ButtonUshImport from './button/ButtonUshImport';
import ButtonUshExport from './button/ButtonUshExport';
import ButtonProfile from './button/ButtonProfile';
import ButtonReport from './button/ButtonReport';
import RateViewFilters from './filter/RateViewFilters';
import TableView from '../tableview/TableView';
import TreeView from '../treeview/TreeView';
import PopupMenu from '../popupmenu/PopupMenu';
import ConfirmMessage from '../message/ConfirmMessage';
import { Realm } from '../../util/realm/realm';

import { getActualRealm } from '../plain/utilPlain';
import { clearFilter, findSorting } from './conditions/util';
import { getCurrentResource, validInteger, containsKey, getDefinedValue, isStringOneOf } from '../../util/tools';
import { 
	getRequestProperties, performApiRequest, 
	QUERY_GETFORM_API_URL,
	QUERY_GETPAGE_API_URL,
	ENTITY_DELETE_API_URL,
	CACHE_GET_STRING_API_URL,
	CACHE_PUT_STRING_API_URL,
} from '../../util/restapi';
import { 
	getButtonMode, getUserInfo, 
	canViewForm, canCreateObject, canReadObject, canUpdateObject, canDeleteObject, canPerformAction, 
	getRateViewProfile, setRateViewProfile
} from '../../util/localStorage';

import refreshIcon from '../../assets/icons/png24x24/Refresh.png';
import firstPageIcon from '../../assets/icons/png24x24/go-first.png';
import lastPageIcon from '../../assets/icons/png24x24/go-last.png';
import prevPageIcon from '../../assets/icons/png24x24/Left.png';
import nextPageIcon from '../../assets/icons/png24x24/Right.png';
import addIcon from '../../assets/icons/png24x24/Add.png';
import editIcon from '../../assets/icons/png24x24/edit.png';
import deleteIcon from '../../assets/icons/png24x24/Delete.png';
import selectIcon from '../../assets/icons/png24x24/Accept.png';
import transitionIcon from '../../assets/icons/png24x24/go-jump.png';
import htmlIcon from '../../assets/icons/png24x24/Document.png';
import iconShowTemplate from '../../assets/icons/png24x24/view.png';
import icon3Lines from '../../assets/icons/png24x24/3lines.png';

export const MODE_BROWSE = 'tableBrowse';
export const MODE_SELECT = 'tableSelect';

export const MODE_TABLE = 'table';
export const MODE_TREE = 'tree';

class RateView extends React.Component {

	/* props:
			app
			holder
			rvOptions
				transition
				autoRefresh
			rvContext
			mode (MODE_BROWSE, MODE_SELECT)
			onInstanceSelected // method
	*/
	constructor(props) {
		super(props);
		this.mode = MODE_BROWSE;
		this.resource = getCurrentResource().components.rateview.RateView;
		this.userInfo = getUserInfo();
		this.refFormShowTemplate = createRef();
		this.refFormTemplate = createRef();
		this.confirmMessageHandler = {};

		this.formInfo = {};
		this.pageData = {};
		this.headers = [];
		this.totalCount = 0;
		this.pageCount = 0;
		this.testStyle = {color: 'red'};
		this.listFilterComponent = [];
		this.activeProfile = null;
		
		/*
			Struct of item is not formalized. It may be table row or tree node.
			Item must have attribute 'id'.
		*/
		this.selectionStack = [];

		if( props.holder )
			props.holder.rvComponent = this;
			
		this.rvOptions = props.rvOptions;
		if( ! this.rvOptions )
			this.rvOptions = {};
					
		this.rvContext = props.rvContext;
		if( ! this.rvContext )
			this.rvContext = {};
		this.rvContext.rateView = this;
		
		let formId = this.rvContext.form;
		this.rvProfile = getRateViewProfile( formId );
		if( this.rvProfile == null ) {
			this.rvProfile = {};
			setRateViewProfile( formId, this.rvProfile );
		}
		
		let tableTreeMode = this.rvOptions.tableTreeMode;
		if( ! tableTreeMode )
			tableTreeMode = MODE_TABLE;
		if( props.mode )
			this.mode = props.mode;
		this.state = {
			isInited: false,
			isFormValid: true,
			invalidFormReasonMessage: '',
			isLoading: false,
			isValid: true, // valid page
			invalidReasonMessage: '', // valid page
			isLeftSideVisible: getDefinedValue(this.rvProfile.isLeftSideVisible, true),
			isPopulated: false,
			isFirstPage: false,
			isLastPage: false,
			currentPage: null,		
			currentPageValid: true,		
			isReset: true,
			selectedIds: '',
			actualQuery: null,
			tableTreeMode: tableTreeMode,
			selectedObjects: [],
			templateId: '',
			hardFilterBodyText: '',
			isSubmitTemplateFormModalOpen: false
		};
		this.useIcons = getButtonMode() == 'icon';
		
		// TODO make names like componentXXX
		this.componentTableView = null;		
		this.treeViewComponent = null;

		this.query = {
			queryId: '',
			page: 1,
			pageSize: 10,
			
			cardColumn: '',
			listColumn: [],
			listPredicate: [],
			listHardFilter: [],
			listSorting: []
		}; 
		if( this.rvOptions.clearDefaultFilter == undefined || this.rvOptions.clearDefaultFilter == null )
			this.rvOptions.clearDefaultFilter = false;
	}
	componentDidMount = async () => {
		if( this.rvOptions.paramCacheId ) {
			let getStringRequest = {
				cacheItemId: this.rvOptions.paramCacheId,
			}
			let response = await performApiRequest( CACHE_GET_STRING_API_URL, getStringRequest );
			if( ! response.success ) {
				this.setState( { isInited: true, isFormValid: false,  invalidFormReasonMessage: response.message} );
				return;
			}
			if( response.data ) {
				let pageParam = JSON.parse( response.data );
				this.rvOptions.transition = pageParam.transition;
				if( this.rvOptions.transition ) {
					this.rvOptions.autoRefresh = this.rvOptions.transition.autoRefresh;
					if( this.rvOptions.autoRefresh == null || this.rvOptions.autoRefresh == undefined )
						this.rvOptions.autoRefresh = true;
					this.rvOptions.clearDefaultFilter = this.rvOptions.transition.clearDefaultFilter;
					this.query.queryTransition = { 
						transitionId: this.rvOptions.transition.transitionId,
						selected: this.rvOptions.transition.selected
					};
				}
			}
		}
		let response = await getActualRealm();
		if( ! response.success ) {
			this.setState( { isInited: true, isFormValid: false,  invalidFormReasonMessage: response.message} );
			return;
		}
		this.realm = new Realm(response.data);
		console.log( "RateView. Realm", this.realm ); 
		
		const request = {
			formId: this.props.rvContext.form
		};
		response = await performApiRequest( QUERY_GETFORM_API_URL, request );
		if( ! response.success ) {
			this.setState( { isInited: true, isFormValid: false,  invalidFormReasonMessage: response.message} );
			return;
		}
		
		
		this.formInfo = response.data; 
		this.rvContext.className = this.formInfo.masterClass;
		this.query.queryId = this.formInfo.formId;
		if( this.rvContext.explicitConditions ) {
			for(let p of this.rvContext.explicitConditions) {
				this.query.listPredicate.push( p );
			}
		}

		if( this.rvProfile.pageSize == undefined )
			this.rvProfile.pageSize = this.formInfo.pageSize;
		this.query.pageSize = this.rvProfile.pageSize;
		this.currentPageSize = this.rvProfile.pageSize;
		
		if( this.props.rvContext.completeInit ) {
			await this.props.rvContext.completeInit();
		}
		
		this.queryOptions = {
			pageSize: this.rvProfile.pageSize,
			cardColumn: this.rvProfile.cardColumn,
			listColumn: [],
			listHardFilter: [],
			listActiveSorting: []
		}		
		for( let f of this.formInfo.listHardFilter ) {
			this.queryOptions.listHardFilter.push({
				filterModel: f,
				title: f.title,
				tooltip: f.tooltip,
				conditionId: 'none',
				listValue: [],
				listValueObject: [],
				active: false,
				bodyText: ''
			});
		}
		
		{
			if( this.rvProfile === undefined )
				this.rvProfile = {};
			if( this.rvProfile.listColumn == undefined )
				this.rvProfile.listColumn = [];
			let visible = [];
			let invisible = [];
			for(let col of this.rvProfile.listColumn) {
				if( containsKey(this.formInfo.listColumn, 'id', col.id ) ) {
					if( col.calculateSum == undefined ) col.calculateSum = false;
					if( col.calculateAvg == undefined ) col.calculateAvg = false;
					if( col.calculateMin == undefined ) col.calculateMin = false;
					if( col.calculateMax == undefined ) col.calculateMax = false;
					if( col.calculateMedian == undefined ) col.calculateMedian = false;
					if( col.visible )
						visible.push( col );
					else {
						col.calculateSum = false;
						col.calculateAvg = false;
						col.calculateMin = false;
						col.calculateMax = false;
						col.calculateMedian = false;
						invisible.push( col );
					}
				}
			}
			for(let col of this.formInfo.listColumn) {
				if( ! containsKey(this.rvProfile.listColumn, 'id', col.id ) ) {
					visible.push( {
						id: col.id, 
						visible: col.defaultVisible,
						calculateSum: false,
						calculateAvg: false,
						calculateMin: false,
						calculateMax: false,
						calculateMedian: false
					} );
				}
			}
			this.rvProfile.listColumn = visible.concat(invisible);
			for(let visibleCol of visible)
				this.queryOptions.listColumn.push( visibleCol );
		}
		if( this.rvProfile.listActiveSorting == undefined ) {
			this.rvProfile.listActiveSorting = [];
			for( const sortingItem of this.formInfo.listInitialSorting) {
				this.rvProfile.listActiveSorting.push( {sortingId: sortingItem.itemId, ascending: sortingItem.ascending} );
			}
		}
		for(let profileSorting of this.rvProfile.listActiveSorting ) {
			let modelSorting = findSorting(this.formInfo.listSorting, profileSorting.sortingId);
			if( modelSorting != null ) {
				this.queryOptions.listActiveSorting.push({
					sortingId: modelSorting.sortingId,
					title: modelSorting.title,
					tooltip: modelSorting.tooltip,
					ascending: profileSorting.ascending
				});
			}
		}
		
		this.setState( { isInited: true } );
		
		if( this.rvOptions.clearDefaultFilter ) {
			for(let filter of this.listFilterComponent) {
				filter.clearFilter();
			}
			for(let hardFilter of this.queryOptions.listHardFilter) {
				clearFilter( hardFilter );
			}
		}

		if( this.rvOptions.autoRefresh )
			this.handleRefresh();
	}

	setLeftSideVisible = (visible) => {
		this.rvProfile.isLeftSideVisible = visible;
		setRateViewProfile(this.formInfo.formId, this.rvProfile);	
		this.setState({isLeftSideVisible: visible});
	}
	registerFilter = ( filterComponent ) => {
		this.listFilterComponent.push( filterComponent );
	}
	unregisterFilter = ( filterComponent ) => {
		for(let i=this.listFilterComponent.length-1; i >= 0; i--) {
			let fc = this.listFilterComponent[i];
			if( fc == filterComponent )
				this.listFilterComponent.splice(i, 1); 
		}
	}
	clearAllFilters = () => {
		for(let filter of this.listFilterComponent) {
			filter.clearFilter();
		}
		for(let hardFilter of this.queryOptions.listHardFilter) {
			clearFilter( hardFilter );
		}
		this.rvOptions.transition = null;
		this.query.queryTransition = null;
		this.setState({hardFilterBodyText: ''})
		this.clearData();		
	}
	clearQueryFilter = ( predicateId ) => {
		var indexFilter = -1;
		for(var i=0; i < this.query.listPredicate.length; i++) {
			if( this.query.listPredicate[i].predicateId == predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter >= 0 ) {
			this.query.listPredicate.splice( indexFilter, 1 );
		}
	}
	setFilterValue = (predicateId, value) => {
		for(var f of this.listFilterComponent) {
			if( f.props.filter.predicateId == predicateId ) {
				f.setValue( value );
				break;
			}
		}
	}

	populatePage = async () => {
		this.setState( { 
			isReset: false, 
			isLoading: true, 
			isPopulated: false, 
			isFirstPage: false, 
			isLastPage: false 
		} );
		
		this.prepareQuery();
		
		let response = await performApiRequest( QUERY_GETPAGE_API_URL, this.query );
		if( response.success ) {
			let data = response.data;
			this.currentPageSize = this.query.pageSize;
			this.updateData( data )
		} else {
			this.setState({
				isReset: false,
				isLoading: false,
				isValid: false, 
				invalidReasonMessage: response.message,
				isPopulated: false, 
			});
		}
	}
	prepareQuery = () => {
		this.query.page = this.state.currentPage;
		this.query.cardColumn = this.queryOptions.cardColumn;
		this.query.listColumn = [];
		for(let col of this.queryOptions.listColumn) {
			this.query.listColumn.push(col);
		}
		this.query.listHardFilter = [];
		for(let f of this.queryOptions.listHardFilter) {
			if( f.active ) {
				this.query.listHardFilter.push({
					predicateId: f.filterModel.predicateId,
					conditionId: f.conditionId,
					listValue: [...f.listValue]
				});
			}
		}
		this.query.listSorting = [];
		for(let s of this.queryOptions.listActiveSorting) {
			this.query.listSorting.push({
				sortingId: s.sortingId,
				ascending: s.ascending
			})
		}		
	}
	updateData = (data) => {
		this.pageData = data;
		this.headers = data.headers;
		this.props.rvContext.data = data.data;
		this.totalCount = data.totalCount;
		this.pageCount = data.pageCount;
		let currentPage = this.state.currentPage 
		if( ! currentPage )
			currentPage = 1;
		if( this.pageCount < currentPage )
			currentPage = this.pageCount;
		this.setState( { 
			isReset: false,
			isLoading: false,
			isValid: true,
			invalidReasonMessage: '',
			isPopulated: true, 
			isFirstPage: (currentPage == 1), 
			isLastPage: (currentPage == this.pageCount ),
			currentPage: currentPage, 
			currentPageValid: true 
		}, this.handleRowSelectionChange );
	}
	handleRefresh = () => {
		if( this.state.tableTreeMode == MODE_TREE ) {
			if( this.treeViewComponent ) {
				this.treeViewComponent.refresh();
				return;
			}
		} else {
			if( this.state.currentPage == null || this.state.currentPage == '' || ! this.state.currentPageValid )
				this.setState({currentPage: 1, currentPageValid: true}, this.populatePage);
			else
				this.populatePage();
		}
	}
	firstPage = () => {
		if( this.state.isFirstPage )
			return;
		this.setState({currentPage: 1, currentPageValid: true}, this.populatePage);
	}
	prevPage = () => {
		if( this.state.isFirstPage )
			return;
		this.setState({currentPage: Number(this.state.currentPage)-1, currentPageValid: true}, this.populatePage);
	}
	nextPage = () => {
		if( this.state.isLastPage )
			return;
		this.setState({currentPage: Number(this.state.currentPage)+1, currentPageValid: true}, this.populatePage);
	}
	lastPage = () => {
		if( this.state.isLastPage )
			return;
		this.setState({currentPage: this.pageCount, currentPageValid: true}, this.populatePage);
	}

	clearData = () => {
		this.setState( { 
			isReset: true, 
			isPopulated: false, 
			isValid: true,
			invalidReasonMessage: '',
			isFirstPage: false, 
			isLastPage: false,
		} );
	}

	getSelectedIds = () => {
		let ids = [];
		if( this.state.tableTreeMode == MODE_TABLE ) {
			let rows = this.getSelectedRows();
			for(let r of rows) {
				ids.push( r.id );
			}
		} else {
			if( this.treeViewComponent ) {
				let nodes = this.treeViewComponent.getSelectedNodes();
				for(let n of nodes) {
					ids.push( n.id );
				}
			}
		}
		return ids;
	}
	getSelectedObjects = () => {
		let ids = [];
		if( this.state.isReset )
			return ids;
		if( this.state.tableTreeMode == MODE_TABLE ) {
			let rows = this.getSelectedRows();
			for(let r of rows) {
				ids.push( r.objectMaster );
			}
		} else {
			if( this.treeViewComponent ) {
				let nodes = this.treeViewComponent.getSelectedNodes();
				for(let n of nodes) {
					ids.push( n );
				}
			}
		}
		return ids;
	}
	getSelectedRows = () => {
		let rows = [];
		if( ! this.props.rvContext.data )
			return rows;
		for( let row of this.props.rvContext.data ) {
			if( row.checked ) {
				rows.push( row );
			}
		}		
		return rows;
	}
	handleTreeNodeSelectionChange = (node, selected) => {
		if( node ) {
			if( selected ) {
				this.selectionStack.push( node )
			} else {
				for(let i=this.selectionStack.length-1; i >= 0; i--) {
					if( this.selectionStack[i].id == node.id )
						this.selectionStack.splice(i,1);
				}
			}
		}
		let selectedObjects = this.getSelectedObjects();
		console.log('Selection STACK', this.selectionStack, selectedObjects)
		this.setState({selectedObjects: selectedObjects});
	}	
	handleRowSelectionChange = (row) => {
		if( row ) {
			if( row.checked ) {
				this.selectionStack.push( row )
			} else {
				for(let i=this.selectionStack.length-1; i >= 0; i--) {
					if( this.selectionStack[i].id == row.id )
						this.selectionStack.splice(i,1);
				}
			}
		}
		let selectedObjects = this.getSelectedObjects();
		this.setState({selectedObjects: selectedObjects});
	}	
	handleCurrentPageValueChange = (e) => {
		var value = e.target.value;
		var valid = value == null || value == '' || validInteger( value ) && value > 0;
		this.clearData();
		this.setState({currentPage: value, currentPageValid: valid});
	}
	
	makeTransition = async (transition) => {
		let ids = this.getSelectedIds();
		if( ids.length == 0 )
			return;
			
		let param = {
			transition: {
				transitionId: transition.transitionId, 
				autoRefresh: transition.autoRefresh,
				clearDefaultFilter: transition.clearDefaultFilter,
				description: transition.description, 
				selected: ids
			}
		}
		console.log('Transition param', param);
		
//		var paramEncoded = encodeURIComponent( JSON.stringify(param) );
//		var url = `${config.PATH}/` + transition.tableFormId + '/' + paramEncoded;

		let putStringRequest = {
			dataType: 'transitionParam',
			data: JSON.stringify(param)
		}
		let response = await performApiRequest( CACHE_PUT_STRING_API_URL, putStringRequest );
		if( response.success ) {
			let paramCacheId = response.data;
			let url = `${config.PATH}/` + transition.tableFormId + '/' + paramCacheId;
			console.log('Open url', url)
			window.open(url);
		} else {
			this.props.app.showResponse( response );
		}
		
	}
	
	submitTemplateShowForm = (templateId) => {
		var rows = this.getSelectedRows();
		var selectedIds = '';
		var first = true;
		for( var row of rows) {
			if( first ) {
				first = false;
			} else {
				selectedIds += ',';
			}
			selectedIds += row.id;
		}
		this.setState(
			{selectedIds: selectedIds, templateId: templateId}, 
			() => {this.refFormShowTemplate.current.submit()} );
	}	
	
	getPlainFormEdit = () => {
		return this.getPlainForm( false );
	}
	getPlainFormView = () => {
		return this.getPlainForm( true );
	}
	getPlainForm = (view) => {
		for( var form of this.formInfo.listPlainForm ) {
			if( form.view == view && canViewForm( form.formId ) ) {
				return form;
			}
		}
		return null;
	}
	setTableTreeMode = (event) => {
		this.clearData();
		let value = event.target.value;
		this.selectionStack = [];
		this.setState({tableTreeMode: value, selectedObjects: [] });
	}
	
	handleInputEdit = (event) => {
		this.clearData();
		var value = event.target.value;
		this.currentPageSize = value;
		if( ! value )
			value = this.rvProfile.pageSize;
		
		this.query.pageSize = value;
		this.rvProfile.pageSize = value;
		setRateViewProfile(this.formInfo.formId, this.rvProfile);	
	} 
	selectInstance = () => {
		var ids = this.getSelectedIds();
		var listObjectMaster = this.getSelectedObjects();
		this.props.onInstanceSelected( ids, listObjectMaster );
	}
	
	addInstance = () => {
		let form = this.getPlainFormEdit();
		let addInstanceURL = `${config.PATH}/` + form.formId + '/0';
		window.open(addInstanceURL);
	}
	editInstanceRO = () => {
		this.editInstance(true);
	}
	editInstance = (readOnly) => {
		let selectedRows = this.selectionStack;
		if( selectedRows.length > 0 ) {
			let form = this.getPlainFormEdit();
			if( form != null ) {
				let id = selectedRows[ selectedRows.length-1 ].id;
				let editInstanceURL = `${config.PATH}/` + form.formId + '/' + id;
				if( readOnly === true )
					editInstanceURL += '-ro';
				window.open(editInstanceURL);
			}
		} 
	}
		
	deleteInstances = () => {
		if( ! this.props.rvContext.data )
			return;
		
		this.confirmMessageHandler.confirm = null;
		this.confirmMessageHandler.doAfterClose = this.realDeleteInstances;
		this.confirmMessageHandler.showMessage( this.resource.msgConfirmDeleteMarked );
	}
	realDeleteInstances = async () => {
		if( ! this.confirmMessageHandler.confirm )
			return;

		let request = {
			formId: this.formInfo.formId,
			listInstanceId: []
		}
		let rows = this.getSelectedRows();
		for( let row of rows ) {
			request.listInstanceId.push( row.id )
		}

		let response = await performApiRequest( ENTITY_DELETE_API_URL, request );
		
		if( response.success ) {
			for( let row of rows ) {
				row.deleted = true;
				row.checked = false;
			}
			this.forceUpdate();
		} else {
			this.props.app.showResponse( response );
		}	
	}

	fetchProfile = (profile) => {
		let rvProfile = this.rvProfile;
		let rvQueryOptions = this.queryOptions;
		let body = {};
		body.pageSize = rvProfile.pageSize;
		body.cardColumn = rvProfile.cardColumn;
		
		body.listColumn = [];
		for(let col of rvProfile.listColumn) {
			body.listColumn.push( {
				id: col.id, visible: col.visible,
				calculateSum: col.calculateSum,
				calculateAvg: col.calculateAvg,
				calculateMin: col.calculateMin,
				calculateMax: col.calculateMax,
				calculateMedian: col.calculateMedian
			} );
		}
		for(let col of rvProfile.listColumn) {
			if( ! col.visible ) {
				body.listColumn.push( {id: col.id, visible: col.visible} );
			}
		}

		body.listFastFilter = [];
		for(let f of this.listFilterComponent ) {
			let ffProfile = null;
			if( f.fetchProfile ) {
				ffProfile = f.fetchProfile();
			}
			if( ffProfile )
				body.listFastFilter.push( ffProfile );
		}
		
		body.listHardFilter = [];
		body.bodyText = '';
		for(let f of rvQueryOptions.listHardFilter) {
			body.listHardFilter.push({
				filterModel: f.filterModel,
				title: f.title,
				conditionId: f.conditionId,
				listValue: [...f.listValue],
				listValueObject: [...f.listValueObject],
				active: f.active,
				bodyText: f.bodyText
			});
			if( f.active ) {
				body.bodyText += f.bodyText + '\n';
			}
		}

		let transition = this.rvOptions.transition;
		if( transition ) {
			body.transition = transition;
		}
		
		body.listActiveSorting = [];
		for(let s of rvProfile.listActiveSorting ) {
			body.listActiveSorting.push( {sortingId: s.sortingId, ascending: s.ascending} );
		}
		this.makeProfileItemsUnique( body );
		
		profile.body = JSON.stringify( body );
	}
	applyProfile = (profileJSON) => {
		this.clearAllFilters();
		this.activeProfile = profileJSON; 
		let profile = JSON.parse( profileJSON.body );
		console.log('apply parsed profile', profile)
		let rvProfile = this.rvProfile; 
		this.makeProfileItemsUnique( profile );
		this.makeProfileItemsUnique( rvProfile );
		let rvQueryOptions = this.queryOptions;

		rvProfile.pageSize = profile.pageSize;
		rvProfile.cardColumn = profile.cardColumn;
		this.currentPageSize = profile.pageSize;
		this.query.pageSize = profile.pageSize;
		rvQueryOptions.cardColumn = profile.cardColumn;

		rvQueryOptions.listColumn = [];
		rvProfile.listColumn = [];
		for(let col of profile.listColumn) {
			if( col.visible ) {
				rvQueryOptions.listColumn.push( {
					id: col.id,
					calculateSum: col.calculateSum,
					calculateAvg: col.calculateAvg,
					calculateMin: col.calculateMin,
					calculateMax: col.calculateMax,
					calculateMedian: col.calculateMedian
				} );
				rvProfile.listColumn.push( {
					id: col.id, visible: col.visible,
					calculateSum: col.calculateSum,
					calculateAvg: col.calculateAvg,
					calculateMin: col.calculateMin,
					calculateMax: col.calculateMax,
					calculateMedian: col.calculateMedian
				} );
			}
		}
		for(let col of profile.listColumn) {
			if( ! col.visible ) {
				rvProfile.listColumn.push( {id: col.id, visible: col.visible} );
			}
		}

		for(let ffProfile of profile.listFastFilter) {
			let filterId = ffProfile.filterId;
			for(let fastFilter of this.listFilterComponent ) {
				if( fastFilter.props.filter.predicateId == filterId ) {
					fastFilter.applyProfile( ffProfile );
					//break;
				}
			}
		}
					
		rvQueryOptions.listHardFilter = [];
		let filterBodyText = '';
		for(let f of profile.listHardFilter) {
			rvQueryOptions.listHardFilter.push({
				filterModel: f.filterModel,
				title: f.title,
				conditionId: f.conditionId,
				listValue: [...f.listValue],
				listValueObject: [...f.listValueObject],
				active: f.active,
				bodyText: f.bodyText
			});
			if( f.active ) {
				filterBodyText += f.bodyText + '\n';
			}
		}

		let transition = profile.transition;
		if( transition ) {
			this.rvOptions.transition = transition;
			this.query.queryTransition = { 
				transitionId: transition.transitionId,
				selected: transition.selected
			};
		}
		
		rvQueryOptions.listActiveSorting = [...profile.listActiveSorting];
		rvProfile.listActiveSorting = [];
		for(let s of rvQueryOptions.listActiveSorting ) {
			rvProfile.listActiveSorting.push( {sortingId: s.sortingId, ascending: s.ascending} );
		}

		setRateViewProfile(this.formInfo.formId, rvProfile);	
		this.setState({hardFilterBodyText: filterBodyText})
		this.handleRefresh();
	}
	/*
		There is a bug. Sometime profile contains items with same id (for example, columns)
		To remove not unique items we call that method
	*/
	makeProfileItemsUnique = (profile) => {
		if( profile.listColumn ) {
			for( let i=profile.listColumn.length-1; i > 0; i-- ) {
				let column = profile.listColumn[i];
				let hasDuplicate = false;
				for(let j=0; j < i; j++) {
					let col = profile.listColumn[j];
					if( column.id == col.id ) {
						hasDuplicate = true;
						break;
					}
				}
				if( hasDuplicate ) {
					profile.listColumn.splice(i, 1);
				}
			}
		}
	}

	renderData = () => {
		if( this.state.isReset ) {
			return (
				<div style={{marginBottom: '100px'}}>
					{this.resource.msgSetConditionsAndRefresh} ( <img src={refreshIcon} /> )
				</div>
			);
		} else if( this.state.isLoading) {
			return (
				<div>
					{this.resource.msgLoading}
				</div>
			);
		} else if( ! this.state.isValid ) {
			return (
				<div>
					{this.resource.msgError}
					<p>
					{this.state.invalidReasonMessage}
					</p>
				</div>
			);
		} else {
			return (
				<TableView rateView={this} tableHeaders={this.headers} tableData={this.props.rvContext.data} />
			);
		}
	}

	render() {
		if( ! this.state.isInited ) {
			return (
				<div>
					{this.resource.msgInitForm}
				</div>
			);
		} 

		if( ! this.state.isFormValid ) {
			return (
				<div style={{margin: '50px', padding: '50px', color: 'red', fontSize: '16pt'}}>
					{this.state.invalidFormReasonMessage}
				</div>
			);
		} 

		let data = null;
		if( this.state.tableTreeMode == MODE_TABLE ) {
			data = this.renderData();
		} else {
			data = (<TreeView treeId={this.formInfo.treeFormId} rateView={this} />)
		}
		
		let styleData = null;
		if( this.props.mode == MODE_SELECT)
			styleData = {width: 'calc(100% - 330px)', overflowX: 'scroll'};
		else
			styleData = {};
		
		return (
			<div className={styles.divRateView}>
				<ControlPanel holder={this} />
				<div className={styles.divRateViewBody}>
					<LeftSide holder={this} />
					<div className={styles.divData} style={styleData}>
						{data}
					</div>
				</div>
				<ConfirmMessage messageHandler={this.confirmMessageHandler} />
			</div>
		);
	}
}

function LeftSide(props) {
	if( ! props.holder.state.isLeftSideVisible )
		return null;
	let cmbTableTreeMode = (null);
	if( props.holder.formInfo.treeFormId && props.holder.rvContext.disableTree != true) {
		cmbTableTreeMode = (
			<select 
				defaultValue={props.holder.state.tableTreeMode} 
				onChange={props.holder.setTableTreeMode}
				style={{marginLeft: '10px'}}
			>
				<option value={MODE_TABLE}>{props.holder.resource.optionModeTable}</option>
				<option value={MODE_TREE}>{props.holder.resource.optionModeTree}</option>
			</select>
		)
	}
	let filters = (null);
	if( props.holder.state.tableTreeMode == MODE_TABLE ) {
		if( props.holder.rvOptions.transition ) {
			let transition = props.holder.rvOptions.transition;
			filters = (
				<React.Fragment>
					<div style={{marginTop: '10px', marginBottom: '10px', padding: '5px', textAlign: 'left'}}>
						{transition.description}
					</div>
					<RateViewFilters rateView={props.holder} hardFilterBodyText={props.holder.state.hardFilterBodyText} />
				</React.Fragment>
			); 
		} else {
			filters = (<RateViewFilters rateView={props.holder} hardFilterBodyText={props.holder.state.hardFilterBodyText} />);
		}
	}
	return (
		<div className={styles.divLeftSide}>
			<div className={styles.divConditions}>
				<div className={styles.divConditionHeader}>
					<div className={styles.divConditionTitle}>
						{props.holder.resource.labelViewConditions}
					</div>
					<ButtonViewConditions rateView={props.holder} />
				</div>
				<div className={styles.divRowsTableTreeMode}>
					{props.holder.resource.labelPageSize}
					<input 
						type='number' name='rowcount' value={props.holder.currentPageSize} 
						onChange={ props.holder.handleInputEdit} 
						style={{width: '70px', marginLeft: '5px'}}
					/>
					{cmbTableTreeMode}
				</div>
				{filters}
			</div>
			<div className={styles.divTools}>
				<LeftSideExternalTools holder={props.holder} />
			</div>
		</div>
	);
}

function ControlPanel(props) {
	var rateView = props.holder;
	var res = rateView.resource;
	if( props.holder.mode == MODE_SELECT ) {
		return (
			<div className={styles.divControlPanel}>
				<ButtonIconText 
					onClick={props.holder.handleRefresh}
					buttonType={'button'} useIcon={props.holder.useIcons} styles={styles}
					text={res.buttonRefresh} tooltip={res.buttonRefreshTooltip} icon={refreshIcon}
				/>
				<div><ButtonsNavigation holder={props.holder} /></div>
				<div><InfoPanel holder={props.holder} /></div>
				<div><ButtonsSelect holder={props.holder} /></div>
			</div>
		)
	} else {
		return ( 
			<div className={styles.divControlPanel}>
				<div style={{
					padding: '5px 7px 0 20px',backgroundColor: 'rgb(200,230,200)',
					fontWeight: 'bold', fontSize: '14pt'
				}}>
					{rateView.rvOptions.formTitle}
				</div>
				<ButtonParameters holder={props.holder} />
				<ButtonIconText 
					onClick={props.holder.handleRefresh}
					buttonType={'button'} useIcon={props.holder.useIcons} styles={styles}
					text={res.buttonRefresh} tooltip={res.buttonRefreshTooltip} icon={refreshIcon}
				/>
				<div><ButtonsNavigation holder={props.holder} /></div>
				<div><ButtonsModify holder={props.holder} /></div>

				<ButtonShowHtml holder={props.holder} />
				<ButtonHtml holder={props.holder} />
				<ButtonPdf holder={props.holder} />
				<ButtonXml holder={props.holder} />
				<ButtonSendEmail holder={props.holder} buttonStyle={{marginLeft: '3px'}} />

				<ButtonTransition holder={props.holder} />

				<ButtonUshExport holder={props.holder} buttonStyle={{marginLeft:'20px'}}/>
				<ButtonUshImport holder={props.holder} buttonStyle={{marginLeft:'5px'}}/>

				<ButtonProfile holder={props.holder} />

				<ControlPanelExternalTools holder={props.holder} />
				<div><InfoPanel holder={props.holder} /></div>
			</div>
		)
	}
}

function ButtonParameters(props) {
	var rateView = props.holder;
	var button = {
		text: rateView.resource.buttonParameters, 
		tooltip: rateView.resource.buttonParametersTooltip,
		icon: icon3Lines
	};
	var menu = { items: [] };
	if( rateView.state.isLeftSideVisible ) {
		menu.items.push( {
			title: rateView.resource.menuHideLeftSide,
			method: () => { rateView.setLeftSideVisible(false) }
		} )
	} else {
		menu.items.push( {
			title: rateView.resource.menuShowLeftSide,
			method: () => { rateView.setLeftSideVisible(true) }
		} )
	}
	return (
		<PopupMenu holder={rateView} style={{marginRight: '15px'}} button={button} menu={menu} show1ItemMenu={true} />
	);
}


function ButtonsNavigation(props) {
	var res = props.holder.resource;

	var visibility = (props.holder.state.tableTreeMode == MODE_TABLE ) ? "" : "hidden";
	var bgCurrentPage = props.holder.state.currentPageValid ? 'White' : 'LightYellow';

	var buttonFirstPageDisabled = ! props.holder.state.isPopulated || props.holder.state.isFirstPage;
	var buttonPrevPageDisabled = ! props.holder.state.isPopulated || props.holder.state.isFirstPage;
	var buttonNextPageDisabled = ! props.holder.state.isPopulated || props.holder.state.isLastPage;
	var buttonLastPageDisabled = ! props.holder.state.isPopulated || props.holder.state.isLastPage;

	var page = props.holder.state.currentPage;
	if( page == null )
		page = '';
		
	return (
		<div style={{marginLeft: '30px', visibility: visibility, display: 'flex'}}>
			<ButtonIconText 
				onClick={props.holder.firstPage} disabled={buttonFirstPageDisabled}
				buttonType={'button'} useIcon={props.holder.useIcons} styles={styles}
				text={res.buttonFirstPage} tooltip={res.buttonFirstPageTooltip} icon={firstPageIcon}
			/>
			<ButtonIconText 
				onClick={props.holder.prevPage} disabled={buttonPrevPageDisabled}
				buttonType={'button'} useIcon={props.holder.useIcons} 
				styles={styles} style={{marginLeft: '3px'}}
				text={res.buttonPrevPage} tooltip={res.buttonPrevPageTooltip} icon={prevPageIcon}
			/>
			<input 
				type='text' size='3' value={page} 
				style={{height: '25px', marginLeft: '10px', marginRight: '10px', backgroundColor: bgCurrentPage}}
				onChange={props.holder.handleCurrentPageValueChange}
			/>
			<ButtonIconText 
				onClick={props.holder.nextPage} disabled={buttonNextPageDisabled}
				buttonType={'button'} useIcon={props.holder.useIcons} 
				styles={styles} style={{marginRight: '3px'}}
				text={res.buttonNextPage} tooltip={res.buttonNextPageTooltip} icon={nextPageIcon}
			/>
			<ButtonIconText 
				onClick={props.holder.lastPage} disabled={buttonLastPageDisabled}
				buttonType={'button'} useIcon={props.holder.useIcons} styles={styles}
				text={res.buttonLastPage} tooltip={res.buttonLastPageTooltip} icon={lastPageIcon}
			/>
		</div>
	);
}

function ButtonsModify(props) {
	return (
		<React.Fragment>
			<div className={styles.divButtonsModify}>
				<ButtonAdd holder={props.holder} />
				<ButtonEdit holder={props.holder} />
				<ButtonChangeOwner holder={props.holder} />
				<ButtonFieldUpdate holder={props.holder} />
				<ButtonGlobalIdUpdate holder={props.holder} />
				<ButtonMergeInstances holder={props.holder} />
				<ButtonDelete holder={props.holder} />
			</div>
		</React.Fragment>
	);
}

function LeftSideExternalTools(props) {
	var holder = props.holder;
	if( holder.rvOptions.leftSideTools )
		return holder.rvOptions.leftSideTools;
	else
		return ( null )
}
function ControlPanelExternalTools(props) {
	var holder = props.holder;
	if( holder.rvOptions.controlPanelTools )
		return holder.rvOptions.controlPanelTools;
	else
		return ( null )
}

function ButtonAdd(props) {
	let rvOptions = props.holder.rvOptions; 
	if( rvOptions.hideButtonAdd )
		return null;
	if( rvOptions.buttonAdd )
		return props.holder.rvOptions.buttonAdd
	let form = props.holder.getPlainFormEdit();
	if( form == null ) {
		return(null);
	} else {
		let allowed = canCreateObject(props.holder.formInfo.masterClass);
		if( rvOptions.allowAddButton )
			allowed = allowed && rvOptions.allowAddButton(props.holder.userInfo); 
		let disabled = props.holder.state.tableTreeMode == MODE_TREE;
		if( allowed ) {
			let url = `${config.PATH}/` + form.formId + '/0'; 
			if( props.holder.useIcons ) {
				return (
					<React.Fragment>
						&nbsp;
						<button className={styles.buttonToolbarIcon} type="button" disabled={disabled} title={props.holder.resource.buttonAddInstanceTooltip}>
							<Link to={url} target='_blank'><img src={addIcon} /></Link>
						</button> 
					</React.Fragment>
				);
			}
			return (
				<React.Fragment>
					&nbsp;
					<button className={styles.buttonToolbarText} type="button" disabled={disabled}>
						<Link to={url} target='_blank' title={props.holder.resource.buttonAddInstanceTooltip}>{props.holder.resource.buttonAddInstance}</Link>
					</button> 
				</React.Fragment>
			);
		} else {
			return (null);
		}
	}
}
function ButtonEdit(props) {
	if( props.holder.props.rvOptions.hideButtonEdit )
		return null;
	let holder = props.holder;
	let userInfo = holder.userInfo;
	let form = holder.getPlainFormEdit();
	if( form == null ) {
		return(null);
	} else {
		let disabled;
		if( holder.state.selectedObjects.length == 0 ) {
			disabled = true;
		} else {
			let obj = holder.state.selectedObjects[0];
			disabled = ! canUpdateObject(userInfo, obj.className, obj.ownerGroup, obj.ownerUser);
			if( holder.formInfo.formId == 'book_table' ) {
				disabled = disabled || ! canPerformAction('edit_book_directly', userInfo);
			}
		}
		return (
			<ButtonIconText 
				onClick={props.holder.editInstance} disabled={disabled}
				buttonType={'button'} useIcon={props.holder.useIcons} styles={styles}
				text={props.holder.resource.buttonEditInstance} 
				tooltip={props.holder.resource.buttonEditInstanceTooltip} icon={editIcon}
			/>
		);
	}
}
function ButtonDelete(props) {
	if( props.holder.props.rvOptions.hideButtonDelete )
		return null;
	var holder = props.holder;
	var userInfo = holder.userInfo;
	var disabled = false;
	if( holder.state.selectedObjects.length == 0 )
		disabled = true;
	else {
		for( let obj of holder.state.selectedObjects) {
			disabled = disabled || ! canDeleteObject(userInfo, obj.className, obj.ownerGroup, obj.ownerUser);
		} 
	}
	var disabled = disabled || holder.state.tableTreeMode == MODE_TREE;
	return (
		<ButtonIconText 
			onClick={holder.deleteInstances} disabled={disabled}
			buttonType={'button'} useIcon={holder.useIcons} styles={styles}
			text={holder.resource.buttonDeleteInstances} 
			tooltip={holder.resource.buttonDeleteInstancesTooltip} icon={deleteIcon}
		/>
	);
}

function ButtonsSelect(props) {
	let res = props.holder.resource;
	return (
		<ButtonIconText 
			onClick={props.holder.selectInstance}
			buttonType={'button'} useIcon={props.holder.useIcons} 
			styles={styles} style={{marginLeft: '20px'}}
			text={res.buttonSelect} tooltip={res.buttonSelectTooltip} icon={selectIcon}
		/>
	);
}

function ButtonTransition(props) {
	if( props.holder.props.rvOptions.hideButtonTransition )
		return null;
	let listTransition = props.holder.formInfo.listTransition;
	let style = {marginLeft: '20px'};
	let button = {
		text: props.holder.resource.buttonTransition, 
		tooltip: props.holder.resource.buttonTransitionTooltip, 
		icon: transitionIcon
	};
	let menu = { items: [] };
	if( listTransition ) {
		for(let transition of listTransition) {
			if( canViewForm(transition.tableFormId, props.holder.userInfo) ) {
				menu.items.push( {
					title: transition.menuTitle,
					method: () => { props.holder.makeTransition(transition) }
				} )
			}
		}
	}
	return (
		<PopupMenu holder={props.holder} style={style} button={button} menu={menu} />
	);
}

function ButtonShowHtml(props) {
	if( props.holder.props.rvOptions.hideButtonShowHtml )
		return null;
	let holder = props.holder;
	let userInfo = holder.userInfo;
	let res = holder.resource;
	let form = holder.getPlainFormEdit();
	let usePlainReadOnly = isStringOneOf( holder.formInfo.formId, 
		['authority_author_table', 'authority_publisher_table', 
			'book_table', 'work_table', 'product_table', 'topic_table',
			'derivative_table', 'honor_table', 'ebook_supplier_table',
			'organization_table', 'library_table', 'provider_table',
			"offer_table", "request_table", 'bookshop_table', "ebook_bank_table",
			"ebook_report_table" 
		] ) && form != null && form.formId != null && form.formId.endsWith('_plain');
	if( usePlainReadOnly ) {
		if( form == null ) {
			return(null);
		} else {
			let disabled = false;
			if( holder.state.selectedObjects.length == 0 ) {
				disabled = true;
			} else {
				let obj = holder.state.selectedObjects[0];
				disabled = ! canReadObject(userInfo, obj.className, obj.ownerGroup, obj.ownerUser);
			}
			return (
				<ButtonIconText 
					useIcon={holder.useIcons} styles={styles} disabled={disabled}
					style={{marginLeft: '30px'}}
					text={res.buttonShow} tooltip={res.buttonShowTooltip} icon={iconShowTemplate}
					onClick={holder.editInstanceRO}
				/>
			);
		}
	}
	
	let disabled = false;
	let template = holder.formInfo.showTemplate;
	if( ! template ) {
		disabled = true;
		template = { templateId: '', title: '', description: ''};
	} else {
		if( holder.state.selectedObjects.length == 0 ) {
			disabled = true;
		} else {
			disabled = false;
			for(let obj of holder.state.selectedObjects)
				disabled = disabled || ! canReadObject(userInfo, obj.className, obj.ownerGroup, obj.ownerUser);
		}
	}
	let formUrl = 'output/html';
	let requestProperties = getRequestProperties( formUrl );
	return (
		<div style={{marginLeft: '30px'}}>
			<form ref={holder.refFormShowTemplate} action={requestProperties.url} method='post' target='_blank'>
				<input type='hidden' name='objects' value={holder.state.selectedIds} />
				<input type='hidden' name='auth' value={requestProperties.authorization} />
				<input type='hidden' name='lang' value={requestProperties.language} />
				<input type='hidden' name='mode' value={''} />
				<input type='hidden' name='template' value={template.templateId} />
				<ButtonIconText 
					useIcon={holder.useIcons} styles={styles} disabled={disabled}
					text={template.title} tooltip={template.description} icon={iconShowTemplate}
					onClick={ () => {holder.submitTemplateShowForm(template.templateId)} }
				/>
			</form>
		</div>
	);		
}
function ButtonHtml(props) {
	if( props.holder.props.rvOptions.hideButtonHtml )
		return null;
	return (
		<ButtonReport holder={props.holder} formUrl={'output/html'} mode={''} 
			style={{marginLeft: '3px'}} 
			text={props.holder.resource.buttonHtml} 
			tooltip={props.holder.resource.buttonHtmlTooltip} 
			icon={htmlIcon} 
		/>
	);
}
function ButtonPdf(props) {
	if( props.holder.props.rvOptions.hideButtonPdf )
		return null;
	return null;
/*	
	return (
		<ButtonReport holder={props.holder} formUrl={'output/html'} mode={''} 
			style={{marginLeft: '3px'}} 
			text={props.holder.resource.buttonHtml} 
			tooltip={props.holder.resource.buttonHtmlTooltip} 
			icon={htmlIcon} 
		/>
	);
*/
}
function ButtonXml(props) {
	if( props.holder.props.rvOptions.hideButtonXml )
		return null;
	return null;
/*	
	return (
		<ButtonReport holder={props.holder} formUrl={'output/html'} mode={''} 
			style={{marginLeft: '3px'}} 
			text={props.holder.resource.buttonHtml} 
			tooltip={props.holder.resource.buttonHtmlTooltip} 
			icon={htmlIcon} 
		/>
	);
*/
}

function InfoPanel(props) {
	let holder=props.holder;
	let info = " ";  
	if( holder.state.isPopulated ) {
		info += props.holder.resource.labelPageNum + ": ";
		info += props.holder.state.currentPage + " / " + props.holder.pageCount + " ";
		info += props.holder.resource.labelRecordCount + ": " + props.holder.totalCount;
	} 
	return (
		<div className={styles.divInfoPanel}>
			{info}
		</div>		
	); 
}

export default RateView;
